import _ from 'lodash';
import {noOpAction} from 'ducks';

export const ACCEPTED_FILE_TYPES = 'image/jpeg, image/png, image/webp, .pdf';
export const ACCEPTED_IMAGE_FILE_TYPES = 'image/jpeg, image/png, image/webp';
export const ACCEPTED_DOCUMENT_FILE_TYPES = '.pdf';

export const UPLOAD_FILE = 'files/UPLOAD_FILE';
export const uploadFile = (
  {
    file,
    signSdk,
    signData,
    startUploadingAction = noOpAction,
    finishUploadingAction = noOpAction,
    storeIdentifierAction = noOpAction,
    storeImageUrlAction = noOpAction
  },
  extraActions = []
) => ({
  type: UPLOAD_FILE,
  payload: {
    file,
    signSdk,
    signData,
    startUploadingAction,
    finishUploadingAction,
    storeIdentifierAction,
    storeImageUrlAction,
    extraActions
  }
});

export const EXPORT_CSV = 'files/EXPORT_CSV';
const EXPORT_CSV_SUCCESS = 'files/EXPORT_CSV_SUCCESS';
const EXPORT_CSV_FAILURE = 'files/EXPORT_CSV_FAILURE';

export const exportCsv = (
  {fileName, exportData, exportSdk},
  successExtraActions = [],
  failureExtraActions = []
) => ({
  type: EXPORT_CSV,
  payload: {
    fileName,
    exportData,
    exportSdk,
    successExtraActions,
    failureExtraActions
  }
});
export const exportCsvSuccess = fileName => ({
  type: EXPORT_CSV_SUCCESS,
  payload: {fileName}
});
export const exportCsvFailure = (fileName, errors) => ({
  type: EXPORT_CSV_FAILURE,
  payload: {fileName, errors}
});

export const EXPORT_CSV_IN_BACKGROUND = 'files/EXPORT_CSV_IN_BACKGROUND';
export const exportCsvInBackground = ({fileName, exportData, exportSdk}) => ({
  type: EXPORT_CSV_IN_BACKGROUND,
  payload: {
    fileName,
    exportData,
    exportSdk
  }
});

export const selectExporting = (state, fileName) =>
  _.get(state.files, `exportCsv.${fileName}.exporting`, false);

export const EXPORT_XLSX_IN_BACKGROUND = 'files/EXPORT_XLSX_IN_BACKGROUND';
export const exportXlsxInBackground = ({fileName, exportData, exportSdk}) => ({
  type: EXPORT_XLSX_IN_BACKGROUND,
  payload: {
    fileName,
    exportData,
    exportSdk
  }
});

export const EXPORT_XLSX = 'files/EXPORT_XLSX';
const EXPORT_XLSX_SUCCESS = 'files/EXPORT_XLSX_SUCCESS';
const EXPORT_XLSX_FAILURE = 'files/EXPORT_XLSX_FAILURE';

export const exportXlsx = (
  {fileName, exportData, exportSdk},
  successExtraActions = [],
  failureExtraActions = []
) => ({
  type: EXPORT_XLSX,
  payload: {
    fileName,
    exportData,
    exportSdk,
    successExtraActions,
    failureExtraActions
  }
});
export const exportXlsxSuccess = fileName => ({
  type: EXPORT_XLSX_SUCCESS,
  payload: {fileName}
});
export const exportXlsxFailure = (fileName, errors) => ({
  type: EXPORT_XLSX_FAILURE,
  payload: {fileName, errors}
});

export const selectXlsxExporting = (state, fileName) =>
  _.get(state.files, `exportXlsx.${fileName}.exporting`, false);

const initialState = {exportCsv: {}, exportXlsx: {}};

const reducer = (state = initialState, action) => {
  const {type, payload} = action;

  switch (type) {
    case EXPORT_CSV:
      return {
        ...state,
        exportCsv: {
          ...state.exportCsv,
          [payload.fileName]: {exporting: true}
        }
      };
    case EXPORT_CSV_IN_BACKGROUND:
      return {
        ...state,
        exportCsv: {
          ...state.exportCsv,
          [payload.fileName]: {exporting: true}
        }
      };
    case EXPORT_CSV_SUCCESS:
      return {
        ...state,
        exportCsv: {
          ...state.exportCsv,
          [payload.fileName]: {exporting: false}
        }
      };
    case EXPORT_CSV_FAILURE:
      return {
        ...state,
        exportCsv: {
          ...state.exportCsv,
          [payload.fileName]: {exporting: false, errors: payload.errors}
        }
      };
    case EXPORT_XLSX:
      return {
        ...state,
        exportXlsx: {
          ...state.exportXlsx,
          [payload.fileName]: {exporting: true}
        }
      };
    case EXPORT_XLSX_IN_BACKGROUND:
      return {
        ...state,
        exportXlsx: {
          ...state.exportXlsx,
          [payload.fileName]: {exporting: true}
        }
      };
    case EXPORT_XLSX_SUCCESS:
      return {
        ...state,
        exportXlsx: {
          ...state.exportXlsx,
          [payload.fileName]: {exporting: false}
        }
      };
    case EXPORT_XLSX_FAILURE:
      return {
        ...state,
        exportXlsx: {
          ...state.exportXlsx,
          [payload.fileName]: {exporting: false, errors: payload.errors}
        }
      };
    default:
      return state;
  }
};

export default reducer;
export {default as filesSaga} from './saga';
